export default __webpack_public_path__ + "static/P_SearchThumb_IN-5907HD_Downloads-e96c49645899677c8b5824a3ed1d73e1.webp";